import { render, staticRenderFns } from "./ContentRating.vue?vue&type=template&id=56aba791&scoped=true"
import script from "./ContentRating.vue?vue&type=script&lang=js"
export * from "./ContentRating.vue?vue&type=script&lang=js"
import style0 from "./ContentRating.vue?vue&type=style&index=0&id=56aba791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aba791",
  null
  
)

export default component.exports